import { render, staticRenderFns } from "./generate-ppt.vue?vue&type=template&id=442bf115&scoped=true"
import script from "./generate-ppt.vue?vue&type=script&lang=js"
export * from "./generate-ppt.vue?vue&type=script&lang=js"
import style0 from "./generate-ppt.vue?vue&type=style&index=0&id=442bf115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bf115",
  null
  
)

export default component.exports